import { Choice } from "@/types";

/** LLM種類(定数) */
export enum LLM_TYPE {
  /** OpenAI */
  OPEN_AI = 1,
  /** Gemini */
  GEMINI = 2,
  /** Gemini */
  CLAUDE = 3,
}

/** LLM種類(選択肢) */
export const LLM_TYPES: Choice[] = [
  { text: "OpenAI", value: LLM_TYPE.OPEN_AI },
  { text: "Gemini", value: LLM_TYPE.GEMINI },
  { text: "Claude", value: LLM_TYPE.CLAUDE },
];

/** ブロック種類(定数) */
export enum BLOCK_TYPE {
  /** システムプロンプト */
  SYSTEM = 1,
  /** ユーザープロンプト */
  USER = 2,
  /** 動的プロンプト */
  VARIABLE = 3,
}

/** ブロックタイプ(選択肢) */
export const BLOCK_TYPES: Choice[] = [
  { text: "システムプロンプト", value: BLOCK_TYPE.SYSTEM },
  { text: "ユーザープロンプト", value: BLOCK_TYPE.USER },
  { text: "動的プロンプト", value: BLOCK_TYPE.VARIABLE },
];

/** ブロックタイプ(チップ色) */
export const BLOCK_TYPE_COLORS: Choice[] = [
  { text: "append", value: BLOCK_TYPE.SYSTEM },
  { text: "primary", value: BLOCK_TYPE.USER },
  { text: "alert", value: BLOCK_TYPE.VARIABLE },
];
